var map = {
	"./black_sprite_0.png": 9586,
	"./black_sprite_1.png": 715,
	"./black_sprite_2.png": 9424,
	"./blue_sprite_0.png": 4599,
	"./blue_sprite_1.png": 958,
	"./blue_sprite_2.png": 3381,
	"./gold_sprite_0.png": 2841,
	"./gold_sprite_1.png": 5936,
	"./gold_sprite_2.png": 9435,
	"./green_sprite_0.png": 3130,
	"./green_sprite_1.png": 1987,
	"./green_sprite_2.png": 7496,
	"./pink_sprite_0.png": 615,
	"./pink_sprite_1.png": 5038,
	"./pink_sprite_2.png": 7778,
	"./red_sprite_0.png": 3882,
	"./red_sprite_1.png": 2739,
	"./red_sprite_2.png": 6984,
	"./white_sprite_0.png": 8720,
	"./white_sprite_1.png": 4969,
	"./white_sprite_2.png": 8882,
	"./yellow_sprite_0.png": 3643,
	"./yellow_sprite_1.png": 2514,
	"./yellow_sprite_2.png": 8601
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1710;